import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getAMLSCommonAlertAssocCustomers } from '../../../redux/actions/common';
import AlertAssocCustomers from './AlertAssocCustomers';

function mapStateToProps(state) {
  const { alertAssocCustomers = {}, alertPartyIdentity = {} } =
    state.amlsCommon;
  const { data: assocCustomers, error, isLoading } = alertAssocCustomers;
  const { data: customerInfo } = alertPartyIdentity;
  const { partyKey = '' } = customerInfo || {};

  return {
    assocCustomers,
    error,
    isLoading,
    customerId: partyKey
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiActions: bindActionCreators(
      { getAMLSCommonAlertAssocCustomers },
      dispatch
    )
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AlertAssocCustomers);
